<template>
  <div class="tab">
    <slot name="tab-selector" />
  </div>

  <div class="tab-content">
    <slot name="tab-content" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Tabs'
})
</script>
<style lang="scss">
button.tab-link {
  background-color: inherit;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 14px 16px;
  transition: 0.5s;
  text-transform: uppercase;

  &.active {
    color: #fff;
    background-color: var(--primary-color);
    i {
      color: #fff;
    }
  }
}

.tab-content {
  background: #f5f8fa;
  height:calc(100% - 45.65px);
  > div {
    padding: 15px 0;
  }
}

@media (max-width: 768px) {
  .tab-content {
    height: auto !important;
    min-height: auto !important;
    max-height: none !important;
    overflow: visible !important;

    > div {
      padding: 10px;
      height: auto !important;
      min-height: auto !important;
      max-height: none !important;
      overflow: visible !important;
    }
  }
}
</style>